import { render, staticRenderFns } from "./PolicyBondRiskDetails.vue?vue&type=template&id=152c1ae0&"
import script from "./PolicyBondRiskDetails.vue?vue&type=script&lang=js&"
export * from "./PolicyBondRiskDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports